import styled from "styled-components";

import { options } from "../styles";

export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  overflow: hidden;
  background-color: ${({ backgroundColor }) => `${backgroundColor}26`};
`;

export const PanelHeader = styled.div`
  display: flex;
  gap: 10px;
  padding: 16px;
  justify-content: ${({ justifyContent }) => justifyContent};

  & > div {
    color: ${({ color }) => color};
  }
`;

export const PanelHeading = styled.h1`
  margin: 0;
  font-size: 16px;
  color: ${({ theme }) => theme.text.input};
  font-weight: 400;
  text-align: ${({ textAlign }) => textAlign};
`;

export const PanelContent = styled.div`
  padding: 16px;
  text-align: ${({ justifyContent }) => justifyContent};
  color: ${({ color }) => color || "inherit"};
  justify-content: ${({ justifyContent }) =>
    options.justifyContent[justifyContent]};
`;

export const Emoji = styled.div`
  display: grid;
  place-content: center;
  width: 18px;
  height: 18px;
`;
